import React from "react";
import { Button, Modal, ModalBody, ModalFooter } from "reactstrap";
import ModalHeader from "@dhn/components/molecules/modal-header";

export default function UnsavedChangesModal({
  isOpen,
  onContinueEditing,
  onDiscard,
  title = "Cambios sin guardar",
  message = "Hay cambios pendientes que no se han guardado.",
  hint = "Si sales ahora, los cambios realizados se perderán.",
  continueLabel = "Seguir editando",
  discardLabel = "Salir sin guardar",
  continueIcon = "fa-pencil",
  discardIcon = "fa-sign-out",
}) {
  return (
    <Modal
      isOpen={isOpen}
      toggle={onContinueEditing}
      centered
      className="dhn-unsaved-modal"
      contentClassName="dhn-unsaved-modal__content"
      backdropClassName="modal-backdrop-blur-light"
      labelledBy="dhn-unsaved-modal-title"
    >
      <ModalHeader
        id="dhn-unsaved-modal-title"
        toggle={onContinueEditing}
        iconClass="fa-exclamation-triangle"
        description={title}
        subtitle={message}
      />
      {hint && (
        <ModalBody className="dhn-unsaved-modal__body">
          <p className="dhn-unsaved-modal__hint">{hint}</p>
        </ModalBody>
      )}

      <ModalFooter className="dhn-unsaved-modal__footer">
        <Button
          type="button"
          color="success"
          className="btn-color-success dhn-unsaved-modal__button"
          onClick={onContinueEditing}
        >
          <i className={`fa ${continueIcon}`} />
          {` ${continueLabel}`}
        </Button>
        <Button
          type="button"
          color="danger"
          className="btn-color-danger dhn-unsaved-modal__button"
          onClick={onDiscard}
        >
          <i className={`fa ${discardIcon}`} />
          {` ${discardLabel}`}
        </Button>
      </ModalFooter>
    </Modal>
  );
}
